import React from 'react';
import { Navigate } from 'react-router-dom';
import { isLoggedIn, getRole } from '../services/auth';

export default function ProtectedRoute({ children, allowedRoles }) {
  if (!isLoggedIn()) return <Navigate to="/login" replace />;
  if (allowedRoles) {
    const role = getRole();
    if (!allowedRoles.includes(role)) return <Navigate to="/login" replace />;
  }
  return children;
}
